import { Deserialize, inheritSerialization } from 'cerialize';
import { ApprovalObjectStatus } from './approval-object-status';
import { ProviderFeeSchedule } from './provider-fee-schedule';

@inheritSerialization(ApprovalObjectStatus)
export class ProviderFeeScheduleApprovalStatus extends ApprovalObjectStatus {
  get providerFeeSchedule(): ProviderFeeSchedule {
    return Deserialize(this.object, ProviderFeeSchedule);
  }
}
